export default __webpack_public_path__ + "91e0868ccb42d271817a65447f2a16b4.png";